/** @format */

const questions = [
  {
    id: 0,
    question: '¿Quién puede inscribirse a la Escuela ZBrush?',
    answer: (
      <div>
        Cualquier persona mayor de 18 años desde cualquier parte del
        mundo que cuente con los requisitos mínimos en su equipo de
        computo y la licencia de ZBrush.
      </div>
    ),
  },
  {
    id: 1,
    question: '¿Cómo son las clases online?',
    answer: (
      <div>
        Serán clases en vídeo a través de nuestra plataforma y
        feedback en vivo por Zoom durante 3 meses. También estarás
        unido(a) a un grupo privado en Discord. Revisa nuestro módulo
        "Método de estudio" para ampliar la información
      </div>
    ),
  },
  {
    id: 2,
    question: '¿Por qué elegir a Libel Academy?',
    answer: (
      <ul>
        <li>
          Tenemos un método de estudio controlado para aprender desde
          cero y en corto tiempo, donde el estudiante recibe todo el
          contenido en los tiempos estipulados, adicionalmente,
          entregamos material de diferentes niveles para que su
          proceso de aprendizaje no se detenga.
        </li>
        <li>
          Nuestros docentes son especialistas en cada una de sus áreas
          (no son generalistas).
        </li>
        <li>
          Los resultados de nuestros estudiantes son realmente
          sorprendentes.
        </li>
        <li>
          Puedes revisar todos nuestros beneficios en nuestra home.
        </li>
      </ul>
    ),
  },
  {
    id: 3,
    question:
      '¿Qué sucede si no puedo asistir a un feedback en vivo?',
    answer: (
      <div>
        Todas nuestras sesiones en vivo quedan grabadas y se cargan en
        nuestra plataforma 24 horas hábiles después para que puedas
        repetirlas por si no pudiste asistir o necesitas repasar.
      </div>
    ),
  },
  {
    id: 4,
    question: '¿Qué conocimientos tendré al finalizar?',
    answer: (
      <div>
        Podrás crear modelos inorgánicos de gran nivel para
        videojuegos y personajes para animación, de modo que estarás
        en la capacidad de hacer cualquier modelo 3D en Blender.
      </div>
    ),
  },
];

export default questions;
